import React, { FC } from 'react';

import Media from 'react-media';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';

import dropdownIndicator from './components/dropdownIndicator';
import selectStyles from './selectStyles';

const mediaQuery = {
    phoneOnly: { maxWidth: 599 },
    tabletPortraitUp: { minWidth: 600 },
    tabletLandscapeUp: { minWidth: 900 },
    desktopUp: { minWidth: 1310 },
};

type Props = {
    label: string | null;
    placeholder?: boolean;
    selected: any;
    parent?: any;
    availableOptions: any;
    selectFunction: any;
    queryString?: string;
    className?: string;
    disabled?: boolean;
    clearable?: boolean;
    searchable?: boolean;
    forceDropDown?: boolean;
    show?: boolean;
};

type Link = {
    pathname: string;
    search?: string;
};

const NavListSelect: FC<Props> = ({
    label = null,
    placeholder = false,
    selected = {},
    parent = null,
    availableOptions = [],
    selectFunction,
    queryString,
    className = '',
    disabled = false,
    clearable = false,
    searchable = false,
    forceDropDown = false,
    show = true,
}: Props) => {
    const IndicatorSeparator = () => null;
    const selectBox = show && (
        <div className={`select-drop-down-container${className?.length > 0 ? ` ${className}` : ''}`}>
            {label && <label className="drop-down-label">{`${label}:`}</label>}
            <Select
                className="Select"
                components={{ DropdownIndicator: dropdownIndicator(false), IndicatorSeparator }}
                isClearable={clearable}
                isDisabled={disabled}
                isSearchable={searchable}
                name="select-box"
                onChange={selectFunction}
                // Only remove options that have show marked as false
                options={availableOptions.filter((o) => o.show !== false)}
                placeholder={placeholder}
                styles={selectStyles}
                value={selected}
            />
        </div>
    );

    const navLink = !forceDropDown && (
        <div className="nav">
            {availableOptions.map((link) => {
                const to: Link = { pathname: `/${parent ? parent : ''}${link.value !== '' ? `/${link.value}` : ''}` };
                let show = link.show;

                if (link.query) {
                    to.search = link.query;
                }

                if (queryString !== undefined) {
                    to.search = queryString;
                }

                if (show || show === undefined) {
                    if (link.action) {
                        return (
                            <a key={link.value} onClick={link.action} className={link.selected ? 'active' : ''}>
                                {link.label}
                            </a>
                        );
                    } else if (link.value.indexOf('http') === -1) {
                        return (
                            <NavLink key={link.value} to={to}>
                                {link.label}
                            </NavLink>
                        );
                    } else {
                        return (
                            <a key={link.value} href={link.value} target="_blank">
                                {link.label}
                            </a>
                        );
                    }
                } else {
                    return null;
                }
            })}
        </div>
    );

    return <Media query={mediaQuery.desktopUp}>{(matches) => (matches && !forceDropDown ? navLink : selectBox)}</Media>;
};

export default NavListSelect;
